<template>
  <div class="fitting center">
    <collapsible
      :step="1"
      :label="`Band size: <b>${underbust_size}&quot;</b>`"
      :has_next="true"
      :max_height="1080"
    >
      <step_1></step_1>
    </collapsible>

    <collapsible
      :step="2"
      :label="`Cup size: <b>${cup_size}&quot;</b>`"
      :has_next="true"
      :max_height="1080"
    >
      <step_2></step_2>
    </collapsible>

    <collapsible
      :step="3"
      :label="`Shape: <b>${shapeToDisplayName(shape)}</b>`"
      :max_height="2500"
    >
      <step_3></step_3>
    </collapsible>

    <collapsible
      :step="4"
      :label="`Waist: <b>${
        skipped_bottoms ? 'skipped' : waist_size
      }</b> Hip: <b>${skipped_bottoms ? 'skipped' : hip_size}</b>`"
      :has_next="true"
      :max_height="3000"
    >
      <step_4></step_4>
    </collapsible>

    <collapsible
      v-if="underbust_size && cup_size && shape"
      :step="5"
      :max-height="9999"
    >
      <step_5 :online_fitting="online_fitting"></step_5>
      <results v-if="fittings"></results>
    </collapsible>

    <div v-if="step == 1" class="form-group">
      <button class="btn btn-danger btn-restart" @click.prevent="reset">
        Start over?
      </button>
    </div>
  </div>
</template>

<script>
import host from "./host";
import shopify from "./mixins/shopify";

import collapsible from "./components/collapsible.vue";
import step_1 from "./components/step_1.vue";
import step_2 from "./components/step_2.vue";
import step_3 from "./components/step_3.vue";
import step_4 from "./components/step_4.vue";
import step_5 from "./components/step_5.vue";
import responsive_youtube from "./components/responsive_youtube.vue";
import results from "./components/results.vue";

function getKeyByValue(object, value) {
  return Object.keys(object).find((key) => object[key] === value);
}

export default {
  mixins: [shopify],
  components: {
    collapsible,
    step_1,
    step_2,
    step_3,
    step_4,
    step_5,
    responsive_youtube,
    results,
  },
  data() {
    return {
      step: window.localStorage.getItem("step") || 1,

      underbust_size: window.localStorage.getItem("underbust_size") || null,
      cup_size: window.localStorage.getItem("cup_size") || null,
      shape: window.localStorage.getItem("shape") || null,
      type: window.localStorage.getItem("type") || "Every Day",
      fit: window.localStorage.getItem("fit") || "normal",

      waist_size: window.localStorage.getItem("waist_size") || null,
      hip_size: window.localStorage.getItem("hip_size") || null,
      skipped_bottoms:
        window.localStorage.getItem("skipped_bottoms") === "true" || null,

      sizes: ["XXS", "XS", "S", "M", "L", "XL", "XXL", "XXXL", "XXXXL"],

      online_fitting_id:
        window.localStorage.getItem("online_fitting_id") || null,
      online_fitting: null,
      fittings: [],

      all_fittings: [],
      filters: [],
    };
  },
  watch: {
    step: function (newValue, oldValue) {
      window.localStorage.setItem("step", newValue);
      if (
        oldValue !== 5 &&
        oldValue !== "5" &&
        (newValue === 5 || newValue === "5")
      ) {
        if (this.waist_size && this.hip_size) {
          this.skipped_bottoms = false;
        }
        this.setOrCreateOnlineFitting();
      }
    },
    underbust_size: function (newValue, oldValue) {
      window.localStorage.setItem("underbust_size", newValue);
    },
    cup_size: function (newValue, oldValue) {
      window.localStorage.setItem("cup_size", newValue);
    },
    shape: function (newValue, oldValue) {
      window.localStorage.setItem("shape", newValue);
    },
    type: function (newValue, oldValue) {
      if (newValue) {
        window.localStorage.setItem("type", newValue);
      } else {
        window.localStorage.removeItem("type");
      }
      if (this.online_fitting_id) {
        this.fetchShopifyProducts();
      }
    },
    fit: function (newValue, oldValue) {
      window.localStorage.setItem("fit", newValue);
      if (this.online_fitting_id) {
        this.fetchShopifyProducts();
      }
    },
    waist_size: function () {
      window.localStorage.setItem("waist_size", this.waist_size);
      if (this.waist_size) {
        this.skipped_bottoms = false;
      }
      this.setOrCreateOnlineFitting();
    },
    hip_size: function () {
      window.localStorage.setItem("hip_size", this.hip_size);
      if (this.hip_size) {
        this.skipped_bottoms = false;
      }
      this.setOrCreateOnlineFitting();
    },
    skipped_bottoms: function () {
      window.localStorage.setItem("skipped_bottoms", this.skipped_bottoms);
      this.setOrCreateOnlineFitting();
    },
    online_fitting_id: function () {
      window.localStorage.setItem("online_fitting_id", this.online_fitting_id);
      if (this.online_fitting_id) {
        this.fetchOnlineFitting();
        this.fetchShopifyProducts();
      }
    },
  },
  computed: {
    type_label() {
      return getKeyByValue(this.types, this.type);
    },
    uk_size() {
      return this.new_uk_measurements(
        this.shape,
        this.underbust_size,
        this.cup_size,
        this.fit
      );
    },
    looser_size() {
      return this.new_uk_measurements(
        this.shape,
        this.underbust_size,
        this.cup_size,
        "loose"
      );
    },
    normal_size() {
      return this.new_uk_measurements(
        this.shape,
        this.underbust_size,
        this.cup_size,
        "normal"
      );
    },
    tighter_size() {
      return this.new_uk_measurements(
        this.shape,
        this.underbust_size,
        this.cup_size,
        "tight"
      );
    },
    isBottomType() {
      return ["Panty"].indexOf(this.type) >= 0;
    },
  },
  created() {
    this.setOrCreateOnlineFitting();
  },
  methods: {
    reset() {
      this.step = 1;
      this.underbust_size = null;
      this.cup_size = null;
      this.shape = null;
      this.type = null;
      this.fit = "normal";
    },
    get_alternate_size(size, index_change) {
      let cur_ind = this.sizes.findIndex((s) => s === size);
      if (cur_ind < 0) {
        return "";
      }

      cur_ind += index_change;

      if (cur_ind >= this.sizes.length) {
        return this.sizes[this.sizes.length - 1];
      } else {
        return this.sizes[cur_ind];
      }
    },
    async setOrCreateOnlineFitting() {
      if (
        (this.step === 5 || this.step === "5") &&
        this.underbust_size &&
        this.cup_size &&
        this.shape
      ) {
        const body = {
          band_size: this.underbust_size,
          cup_size: this.cup_size,
          shape: this.shape,
          waist_size: this.waist_size,
          hip_size: this.hip_size,
        };

        if (this.waist_size === "" || this.hip_size === "") {
          body.waist_size = null;
          body.hip_size = null;
        }

        if (this.online_fitting_id) {
          const response = await fetch(
            `${host}/api/fittings/online_fitting/?online_fitting_id=${this.online_fitting_id}`,
            {
              method: "PUT",
              headers: {
                "X-CSRFToken": window.csrfmiddlewaretoken,
                "Content-Type": "application/json",
              },
              body: JSON.stringify(body),
            }
          );

          if (response.status === 200) {
            const json = await response.json();
            this.online_fitting_id = json.id;
            this.online_fitting = json;
            await this.fetchShopifyProducts();
          } else {
            this.online_fitting_id = null;
            this.setOrCreateOnlineFitting();
          }
        } else {
          const response = await fetch(`${host}/api/fittings/online_fitting/`, {
            method: "POST",
            headers: {
              "X-CSRFToken": window.csrfmiddlewaretoken,
              "Content-Type": "application/json",
            },
            body: JSON.stringify(body),
          });

          if (response.status === 201) {
            const json = await response.json();
            this.online_fitting_id = json.id;
            this.online_fitting = json;
            await this.fetchShopifyProducts();
          } else {
            // add error here
          }
        }
      } else {
        if (!this.underbust_size) {
          this.step = 1;
        } else if (!this.cup_size) {
          this.step = 2;
        } else if (!this.shape) {
          this.step = 3;
        }
      }
    },
    async fetchShopifyProducts() {
      if (!this.type) {
        return;
      }

      window.fbq("track", "Lead");

      this.fittings = null;

      const response = await fetch(
        `${host}/api/fittings/fitting/?online_fitting_id=${this.online_fitting_id}&product_type=${this.type}&fit=${this.fit}`,
        {
          method: "GET",
          headers: {
            "Cache-Control": "no-store",
          },
        }
      );

      if (response.status === 200) {
        const json = await response.json();
        this.fittings = json.products;
        this.filters = json.filters;
        this.all_fittings = JSON.parse(JSON.stringify(this.fittings));
      } else {
        // add error here
      }
    },
    async fetchOnlineFitting() {
      const response = await fetch(
        `${host}/api/fittings/online_fitting/?online_fitting_id=${this.online_fitting_id}`,
        {
          method: "GET",
          headers: {
            "Cache-Control": "no-store",
          },
        }
      );

      if (response.status === 200) {
        const json = await response.json();
        this.online_fitting = json;
      } else {
        this.setOrCreateOnlineFitting();
      }
    },
    shapeToDisplayName(shape) {
      if (shape === "Standard") {
        return "Round";
      } else if (shape === "Swooping") {
        return "Swooping";
      } else if (shape === "Sagging") {
        return "Relaxed";
      } else if (shape === "Large") {
        return "Large";
      } else if (shape === "Small") {
        return "Small";
      } else if (shape === "Tubular") {
        return "Conical";
      } else if (shape === "Pigeon") {
        return "Flattened";
      }
    },
  },
};
</script>

<style lang="less">
.fitting > .form-group {
  margin-top: 15px;
  margin-bottom: 0px;
}
img {
  max-width: 100%;
  margin: 0 auto;
}
.center {
  text-align: center;
}
.clickable,
button {
  cursor: pointer;
}
.form-group {
  margin-bottom: 15px;
}
.form-control {
  width: 300px;
  padding: 15px;
}
.btn.selected {
  color: white;
  background-color: gray;
}
.btn-primary {
  padding: 15px;
  background-color: #fa1f97;
  color: white;
}
.btn-danger {
  padding: 10px;
  color: white;
  background-color: red;
}
.btn-next {
  padding: 15px 90px;
}
.btn-skip {
  background-color: #0187cf;
}
.btn-restart {
  background-color: #00bfd4;
}
.btn-skip-step {
  background-color: transparent;
  color: black;
  border: none;

  &:hover {
    text-decoration: underline;
  }
}
.step-label {
  display: inline-block;
  border-bottom-left-radius: 50px;
  border-bottom-right-radius: 50px;
  width: 100px;
  height: 50px;
  background-color: #0187cf;
  color: white;
  font-size: 25px;
  line-height: 37px;
}
form.slider {
  border-top: #e8e9eb solid 1px;
}
h2,
h3 {
  font-weight: normal;
}
h3 {
  margin-top: 0;
}
h2.clickable {
  background-color: #f7f3f0;

  .step {
    color: #0187cf;
  }
}
.selected {
  border: #fa1f97 1px solid;
}
</style>
